module.exports = __webpack_public_path__ + "img/avatar.6a7cdfe8.png";